/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyUserResponse
 */
export interface VerifyUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyUserResponse
     */
    userIsValidated?: boolean;
}

/**
 * Check if a given object implements the VerifyUserResponse interface.
 */
export function instanceOfVerifyUserResponse(value: object): value is VerifyUserResponse {
    return true;
}

export function VerifyUserResponseFromJSON(json: any): VerifyUserResponse {
    return VerifyUserResponseFromJSONTyped(json, false);
}

export function VerifyUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userIsValidated': json['userIsValidated'] == null ? undefined : json['userIsValidated'],
    };
}

export function VerifyUserResponseToJSON(json: any): VerifyUserResponse {
    return VerifyUserResponseToJSONTyped(json, false);
}

export function VerifyUserResponseToJSONTyped(value?: VerifyUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIsValidated': value['userIsValidated'],
    };
}

